module.exports = __webpack_public_path__ + "img/align_left.cc49bdf0.svg";